import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IObjectAttributes } from "../../services/attribute-data-service/Models";

export type UseObjectsAttributeValuesParameters = {
    organizationID: number,
    groupID: number,
    attributeName: string
} & BaseUseQueryParameters<IObjectAttributes | undefined>;

export function useObjectsAttributeValues({
    organizationID,
    groupID,
    attributeName,
    enabled,
    onError,
    onSuccess,
}: UseObjectsAttributeValuesParameters) {
    return useQuery<IObjectAttributes, RestError>(
        keys.objectsAttributeValues(organizationID, groupID, attributeName),
        ({ signal }) => {
            return AttributeDataService.getObjectsAttributeValues(
                organizationID,
                groupID, 
                attributeName,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            //staleTime: Infinity
            staleTime: 0,
            //refetchOnMount: 'always'
            refetchOnWindowFocus: false

        }
    );
}